
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "ffe01a0d845c323caeb6267bb3224f7f1b371428",
  "nuxt": {
    "buildId": "52f56ce7-9993-4da1-a599-91bce19b43a5"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
